import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';
import { fetchCompetitionMetrics } from '../../../../../../api/MetricsService';
import Auth from '../../../../../../routes/Auth';

import { pickPercent } from "../../../../../../components/analysis/utils";
import { handleSelectChange, arrayUniqueFilter } from '../../../utils';

import IconTableHelp from "../../../../../../containers/assets/icon-table-help.svg";
import VerticalBarChart from "../../../../../../components/analysis/vertical-bar";

import {
  ChartWrapper,
  ChartTitle,
  ChartData
} from '../../../components/ui';

import BannerLayout from '../../../layouts/banner';
import Teams, { teamsEndpoint } from '../../../../../../api/Teams';

class MarketShareStep5 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      data: []
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;

    const round = rounds.find(i => Number(i.number) === Number(activeRound));
    const roundId = round ? round.id : 0;

    Promise.all([
      getRequest(teamsEndpoint()),
      fetchCompetitionMetrics(null, roundId)
    ]).then(res => {
      const metricsReports = res[1];

      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Awareness").teams.filter(arrayUniqueFilter);

      const teams = res[0].body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      const competition_id = metricsReports.find(i => i.team === team_id).competition;

      const metricsreportsWithCompetitionId = metricsReports.filter(i => i.competition === competition_id);
      const data = pickPercent(teams, metricsreportsWithCompetitionId, 'product_awareness');

      this.setState({
        loaded: true,
        teamsToShow,
        selectedTeamId: Number(team_id),
        allTeamsCount: teams.length,
        data
      })
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      data
    } = this.state;

    const { previousShownErrors } = this.props;

    const customColors = Teams.competitiveColors(data);

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Market share"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams could improve their product promotion.`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p>The chart shows each team's product awareness this round. Teams get flagged when their awareness is in the bottom two, or at least 30% below the top team. That signals the product isn't reaching enough customers. The Business Case has general spend guidance; Team Reports → Marketing Analysis shows how each team's spend, and their competitors', actually landed.</p>
            <p><strong>Note:</strong> product awareness declines by 25% each round if teams do not invest in promotions.</p>
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <ChartWrapper>
              <ChartTitle>
                Product Awareness
                <img alt="Product Awareness icon help" src={IconTableHelp} />
              </ChartTitle>
              <ChartData>
                <VerticalBarChart
                  data={data}
                  prefix={""}
                  suffix={"%"}
                  precision={2}
                  customColors={customColors}
                  showCategoryLabels={false}
                  instructorData={null}
                />
              </ChartData>
            </ChartWrapper>
          </Fragment>
        )}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default MarketShareStep5;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/market-share/step5.js